webpackJsonp([23],{

/***/ 1075:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "d-flex align-flex-start space-evenly pb-3 pt-4 px-5",
    style: (("border-bottom:0.1rem solid " + (_vm.globalColors.primary)))
  }, [_c('addressData'), _vm._v(" "), _c('billingData')], 1), _vm._v(" "), _c('section', {
    staticClass: "d-flex wrap"
  }, [_c('div', {
    staticClass: "flex-65"
  }, [_c('ordered-products'), _vm._v(" "), _c('payment-method')], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-15"
  }, [_c('purchase-summary')], 1)]), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 433:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(803),
  /* template */
  __webpack_require__(1075),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 803:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Payment',
	components: {
		addressData: function addressData() {
			return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 701));
		},
		appFooter: function appFooter() {
			return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 463));
		},
		billingData: function billingData() {
			return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 702));
		},
		paymentMethod: function paymentMethod() {
			return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 988));
		},
		purchaseSummary: function purchaseSummary() {
			return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 700));
		},
		orderedProducts: function orderedProducts() {
			return __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, 984));
		}
	}
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/23.49a27cda5821b1475e17.js